<template>
    <ul class="flex-level tabs-list">
        <li
            v-for="tab in tabs"
            :key="tab.id"
            class="flex-row px-3 py-2 fs-3 tab-item"
            :class="{ 'tab-item--active': tab.id === activeTab }"
            @click="$emit('tab-clicked', tab.id)"
        >
            {{ tab.label }}
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        activeTab: {
            type: String,
            required: true,
        },
    },
    emits: ['tab-clicked'],
};
</script>

<style scoped lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

ul.tabs-list {
    li.tab-item {
        cursor: pointer;
        color: $gray-60;
        font-weight: $font-weight-semibold;
        transition: 0.5s;
        &.tab-item--active {
            transition: 0.5s;
            color: $primary-50;
            background-color: $primary-10;
            border-radius: var(--spacing-0);
        }
        &:hover {
            color: $primary-50;
        }
    }
}
ul {
    margin: 0;
}
</style>
